(function (){
    'use strict';
    angular
        .module('tmgApp')
        .factory('BonusObjMonth', BonusObjMonth);

    BonusObjMonth.$inject = ['$resource'];

    function BonusObjMonth ($resource) {
        var resourceUrl =  'api/bonusObjMonth';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();
